import Breadcrumb from "../components/Breadcrumb";
import { SdfLink, SdfBox, SdfCarousel, SdfCarouselItem} from "@synerg/react-components";
import shutterStock1 from "../assets/images/shutterStock1.jpg";
import shutterStock2 from "../assets/images/codeSampleMasked.png";
import shutterStock3 from "../assets/images/shutterStock3.jpg";
import shutterStock4 from "../assets/images/shutterStock4.jpg";
import laptop from "../assets/images/laptop.png";
import wrench from "../assets/images/wrench.svg";
import lock from "../assets/images/Lock.svg";
import piggyBank from "../assets/images/piggyBank.svg";
import highFive from "../assets/images/highFive.svg";
import './EmbeddedPay.css'
import embeddedDev_Compliance from "../assets/images/embeddedDev_Compliance.png";
import embeddedDev_Security from "../assets/images/EmbeddedDev_Security.png";
import EmbeddedDev_ExpertSupport from "../assets/videos/EmbeddedDev_ExpertSupport.mp4";
import EmbeddedDev_Flexibility from "../assets/videos/EmbeddedDev_Flexibility.mp4";
import img from "../assets/images/image.png";
import useMediaQuery from "../hooks/useMediaQuery";
import ADPLogo from "../assets/images/ADPLogo.png";
import checkmark from "../assets/images/checkmark.png";
import tablet from "../assets/images/tablet.png";
import check from "../assets/images/check.png";


const FeatureItem = ({ boldText, description, subText, styles = '', lastText = '', padding='' }) => {
  const isSM = useMediaQuery('(max-width: 600px)')
  const descriptionWithStyles = styles ? <SdfLink href="https://www.adp.com/about-adp/data-security.aspx" className="no-underline" target="_blank"> 
  <span style={{ ...styles }}>{description}</span> 
  </SdfLink> : <span >{description}</span>

  const subTextWithStyles = styles ? <SdfLink href="https://www.adp.com/about-adp/data-security.aspx" className="no-underline" target="_blank"><div className="inline sm:block" style={{ ...styles }}>{subText}</div></SdfLink>
  : <div className="inline sm:block">{subText}</div>
 
return <div>
 { !isSM ? <>  <div className={`${padding ? padding :'pt-3'} flex whitespace-nowrap`}>
    <img src={check} alt="checkmark" style={{ width: '23px', height: '18px' }} className="pr-2 md:pr-4" />
    <span className="font-medium lg:font-bold pr-1">{boldText}</span>
    {lastText && <span>{lastText}&nbsp;</span>}
    {descriptionWithStyles}
  </div>
   <div className="pl-8 md:pl-10"> {subTextWithStyles} </div>
  </>  : <div>
  <div className="w-full flex pt-4">
  <img src={check} alt="checkmark" style={{ width: '23px', height: '18px' }} className="pr-3 md:pr-4" />
   <div><span className="font-medium font-bold">{boldText}</span>  {lastText && <span>{lastText}&nbsp;</span>} {descriptionWithStyles} {subTextWithStyles}</div>
  </div>
    </div>}
  </div>
};

const EmbeddedPayroll = () => {

  const breadcrumbPath = [
    { name: "Home", route: "/" },
    {
      name: "Getting Started / Embedded Payroll",
      route: "/getting-started/embedded-payroll",
    },
  ];

  const isSM = useMediaQuery('(max-width: 600px)')

  return (<div className="min-h-screen overflow-hidden">
    <div className="pl-10 md:pr-0 mr-20">
      <Breadcrumb path={breadcrumbPath} />
    </div>
    <div className="flex flex-col pb-8 gap-8 lg:pl-0  p-3 md:pl-12 xl:pb-0 lg:flex-row  lg:justify-center lg:items-center mx-4 my-4 md:mt-10 xl:mb-32 lg:gap-32 md:gap-10  section-styles column-flex">
      <div className="flex flex-col gap-10 auto-width first-section">
        <div>
          <span className="font-bold md:leading-none font-default size-font"> End-to-end embedded <br />
            payroll, backed by ADP<sup className="font-normal text-md">®</sup> </span>
        </div>
        <div className="font-normal text-lg font-default lg:leading-md w-full whitespace-normal">
          Power your platform with a proven payroll solution. Built <br className="hidden md:inline" /> on over 75 years of expertise, ADP Embedded Payroll <br className="hidden md:inline"/>delivers an industry-leading solution, now fully integrated <br className="hidden md:inline" />into your platform.
        </div>
        <div className="flex flex-col md:flex-row pb-4 xl:pb-0">
          <SdfLink
            target='_blank'
            className="md:pr-3 primary-image"
            emphasis="primary"
            href='https://www.adp.com/what-we-offer/products/adp-embedded-payroll.aspx#bop'
          >
            Start Building
          </SdfLink>
          <SdfLink
            target='_blank'
            emphasis="secondary"
            href='https://adpembeddedpayroll.readme.io/docs/overview-1'
            className="pt-3 md:pt-0 secondary-image"
          >
            View Developer Documentation
          </SdfLink>
        </div>
      </div>
      <div className="flex relative auto-width image-absolute">
        <div className="grid grid-cols-2 gap-2 md:gap-4 md:mb-24">
          <img src={shutterStock1} alt="A man working on a computer" className="rounded-lg grideImage-style" />
          <img src={shutterStock2} alt="code syntax displayed on a screen" className="rounded-lg grideImage-style" />
          <img src={shutterStock3} alt="woman standing while holding a laptop, ready to present." className="rounded-lg grideImage-style" />
          <img src={shutterStock4} alt="A man ready to assist customers" className="rounded-lg grideImage-style" />
        </div>
        <div className="absolute laptop-position">
          <img src={laptop} alt="laptop" className="laptop-image" />
          <div className="absolute box-styles">

            <SdfBox variant="shadowed"
              className="flex flex-row gap-2 md:gap-6 size-padding" >
              <img src={checkmark} alt="checkmark" className="checkMark-image" />
              <div className="flex flex-col justify-center">
                <div className="font-black leading-sm text-xs md:text-2xl">Success!</div>
                <div className="text-sm text-font">Your payroll has been submitted.</div>
              </div>
            </SdfBox>

          </div>
        </div>
      </div>
    </div>
    <div className="bg-action-primary-50 lg:h-lg">
      <div className="pt-16 font-black text-center text-4xl md:text-3xl lg:text-4xl pr-8 pl-6 md:pr-24">
        Don’t build payroll — embed it
      </div>
      <div className="mt-10 md:mt-4 lg:mt-12">
        <div className="flex flex-col md:row-gap-4 lg:row-gap-0 justify-center items-center lg:flex-row lg:justify-center  xl:col-gap-24 lg:col-gap-20">
          <div className="grid grid-rows-2">
            <img src={wrench} className="pb-4 lg:pb-8 md:pl-2 image-style" alt="wrench" />
            <div className="grid-section">
              <div className="font-medium">
                <span className="pl-6 md:pl-4 lg:pl-6 inline md:block">BUILT-IN </span> <span className="inline md:block">COMPLIANCE </span>
                <span className="pl-0 md:pl-4 inline md:block">SUPPORT</span>
              </div>
              <div className="text-sm pt-3">
                <span className='inline md:block'>
                  Automated tax and
                </span>
                <span className='inline md:block md:-ml-8'>
                  compliance handling across
                </span>
                <span className='block md:pl-5 center-text'>
                  all 50 states
                </span>
              </div>
            </div>
          </div>
          <div className="grid grid-rows-2">
            <img src={lock} className="pb-4 md:pl-6 lg:pb-8 image-style" alt="lock" />
            <div className="grid-section">
              <div className="font-medium">
                <div className="pr-2 center-text">ENTERPRISE-GRADE</div>
                <div className=" text-center md:pr-4">SECURITY</div>
              </div>
              <div className="text-sm pt-3 ">
                <span className='inline md:block pl-4'>
                  Get industry-leading
                </span>
                <span className='inline md:block md:text-left'>
                  encryption and security for
                </span>
                <span className='block text-center pr-1'>
                  payroll data
                </span>
              </div>
            </div>
          </div>
          <div className="grid grid-rows-2">
            <img src={piggyBank} className="pt-1 md:pt-0 pb-4 pr-4 md:pr-0 lg:pb-8 md:pl-6 image-style" alt="piggy bank" />
            <div className="grid-section">
              <div className="font-medium center-text">
                <div className="inline md:block pr-1">INTEGRATED BANK</div>
                <div className="inline md:block text-center pr-6">VALIDATION</div>
              </div>
              <div className="text-sm pt-2 pb-3">
                <div className='pr-2 md:-ml-6 inline md:block'>
                  Prevent errors and fraud during
                </div>
                <div className='inline md:block md:text-start md:pl-3'>
                  payroll processing
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-rows-2">
            <img src={highFive} className="md:pt-0 pb-4 lg:pb-8 md:pl-16 lg:pl-0 image-style" alt="High Five" />
            <div className="grid-section">
              <div className="font-medium md:pr-12 center-text">
                <div className="inline md:block md:pr-8 md:pl-8 lg:-ml-8 lg:pl-0">FAST, FRICTIONLESS</div>
                <div className="pl-1 inline md:block md:ml-16 lg:ml-1">ADOPTION</div>
              </div>
              <div className="text-sm pt-3">
                <span className='block lg:-ml-12 lg:pl-0 md:pl-4'>
                  Developer-friendly integration for
                </span>
                <span className='block pl-12 lg:-ml-4 lg:pl-0 '>
                  seamless payroll setup
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="bg-action-default-50">
      <div className="text-center p-10 md:p-0">
        <div className="font-black text-4xl lg:text-4xl md:text-2xl  text-heading-04 pt-4 lg:pt-20 md:pt-10 font-default">Launch a payroll solution built by the experts</div>
        <div className="font-normal text-md md:text-xl lg:leading-sm pt-4 md:pt-5 font-default lg:pr-8">Offering payroll is easy when you partner with ADP.</div>
      </div>
    { !isSM ? <div className="pt-4 md:pt-20 md:px-10 lg:px-48 gap-8 md:gap-10 flex flex-col xl:flex-row align-boxes">
        <SdfBox
          variant="shadowed"
          spacing="loose"
          className="flex-1 relative lg:min-w-0 pb-16"
        >
          <div className="top-image" >
            <img src={checkmark} alt="checkmark" style={{ width: '94px', height: '94px' }} />
          </div>

          <div className="text-center font-bold  text-xl md:text-2xl leading-md pt-12">WHAT WE DO</div>
          <div className="lg:pl-10 lg:pt-2">
            <div className="font-bold text-xl md:text-3xl md:pl-5"><div>From compliance to payments, we’ve </div><div style={{marginLeft: "7ch"}}>got you covered</div></div>
          </div>
          <div className="lg:pt-4 lg:px-10">
            <FeatureItem
              boldText="Embedded payroll engine"
              description="with pre-built compliance and tax"
              subText="handling"
            />
            <FeatureItem
              boldText="Automated tax calculations and filings"
              description="across all states"
              subText="jurisdictions"
            />
            <FeatureItem
              boldText="Scalable payments infrastructure "
              description="for direct deposits and"
              subText="alternative methods"
            />
            <FeatureItem
              boldText="Risk and fraud monitoring"
              description="with built-in security and"
              subText="compliance audits"
            />
            <FeatureItem
              boldText="Developer-friendly APIs"
              description="for payroll processing and employee"
              subText="management"
            />
            <FeatureItem
              boldText="Access to live support and detailed documentation "
              description="for smooth"
              subText="technical implementation"
            />
          </div>
        </SdfBox>

        <SdfBox
          variant="shadowed"
          spacing="loose"
          className="md:pt-2 flex-1 relative lg:min-w-0 pb-16"
        >
          <div className="top-image" >
            <img src={tablet} alt="tablet" style={{ width: '94px', height: '94px' }} />
          </div>

          <div className="text-center font-bold  text-xl md:text-2xl leading-md pt-16">WHAT YOU DO</div>
          <div className="lg:pl-10 lg:pt-2 md:pl-10">
            <div className="font-bold text-xl md:text-3xl md:pl-4"><div>Connect our payroll to your platform — </div> <div style={{marginLeft: '8.5ch'}}>it’s that simple</div></div>
          </div>
          <div className="lg:pt-4 lg:px-10">
            <FeatureItem
              boldText="Integrate ADP APIs"
              description="into your platform for payroll functionality."
            />
            <FeatureItem
              boldText="Leverage pre-built user journeys"
              description="to implement and launch"
              subText="quickly."
              padding="pt-8"
            />
          </div>
        </SdfBox>
      </div> : <SdfCarousel class="flex justify-center items-center w-full">
        <SdfCarouselItem>
           <div className="parent-div">
           <SdfBox
          variant="shadowed"
          spacing="loose"
          className="relative lg:min-w-0 pb-16"
        >
          <div className="top-image" >
            <img src={checkmark} alt="checkmark" style={{ width: '94px', height: '94px' }} />
          </div>

          <div className="text-center font-bold text-xl leading-md pt-12">WHAT WE DO</div>
          <div className="lg:pl-10 lg:pt-2">
            <div className="font-bold text-3xl pl-5 whitespace-nowrap"><div>From compliance to </div><div>payments, we’ve got </div> <div style={{marginLeft: "2.5ch"}}>you covered</div></div>
          </div>
          <div className="pt-4">
          <FeatureItem
              boldText="Embedded payroll engine"
              description="with pre-built compliance and tax"
              subText="handling"
            />
            <FeatureItem
              boldText="Automated tax calculations and filings"
              description="across all states"
              subText="jurisdictions"
            />
            <FeatureItem
              boldText="Scalable payments infrastructure "
              description="for direct deposits and"
              subText="alternative methods"
            />
            <FeatureItem
              boldText="Risk and fraud monitoring"
              description="with built-in security and"
              subText="compliance audits"
            />
            <FeatureItem
              boldText="Developer-friendly APIs"
              description="for payroll processing and employee"
              subText="management"
            />
            <FeatureItem
              boldText="Access to live support and detailed documentation "
              description="for smooth"
              subText="technical implementation"
            />
            
          </div>
        </SdfBox>
           </div>
        </SdfCarouselItem>
        <SdfCarouselItem>
           <div className="parent-div">
           <SdfBox
          variant="shadowed"
          spacing="loose"
          className="flex-1 relative lg:min-w-0 pb-16"
        >
          <div className="top-image" >
            <img src={checkmark} alt="checkmark" style={{ width: '94px', height: '94px' }} />
          </div>

          <div className="text-center font-bold text-xl leading-md pt-12">WHAT YOU DO</div>
          <div className="lg:pl-10 lg:pt-2">
            <div className="font-bold text-3xl pl-5 whitespace-nowrap"><div>Connect our payroll </div><div>to your platform — </div> <div style={{marginLeft: "2.5ch"}}>it’s that simple</div></div>
          </div>
          <div className="pt-4">
          <FeatureItem
              boldText="Integrate ADP APIs"
              description="into your platform for payroll functionality."
            />
            <FeatureItem
              boldText="Leverage pre-built user journeys"
              description="to implement and launch"
              subText="quickly."
              padding="pt-8"
            />
          </div>
        </SdfBox>
           </div>
        </SdfCarouselItem>
        </SdfCarousel>}
      <div className="pb-4 text-center mt-4 md:mt-4 xl:pb-0">
        <SdfLink
          target='_blank'
          className="mx-auto my-10 md:my-16"
          emphasis="primary"
          href='https://www.adp.com/what-we-offer/products/adp-embedded-payroll.aspx'
        >
          Explore Benefits
        </SdfLink>
      </div>
    </div>
    <div style={{ backgroundColor: "#EEF4FE" }}>
      <div className="flex  flex-col justify-center items-center h-full pt-10 pb-20 md:pt-20 md:pb-40">
        <div className="relative p-1 md:p-4">
          <SdfBox
            variant="shadowed"
            spacing="loose"
          >
            <div className="lg:pt-16 lg:pl-12 lg:pr-16">
              <div className="text-3xl leading-lg pb-4  md:whitespace-nowrap">
                <span className="md:pl-5 lg:pl-10">“The flexibility that ADP Embedded Payroll offers is </span><br className="hidden md:block" /> crucial for developers. With the choice of end-to-end APIs<br className="hidden md:block" /> <span className="md:block text-center">or pre-built <span className="block md:inline text-center">payroll interfaces ,</span> <span className="block md:inline text-center">integration is</span> </span> <span className="pl-4 lg:pl-4">straight-forward. ADP  <span className="block md:inline text-center">takes care of the</span> complexities of</span> <br className="hidden md:block" /> payroll compliance and security, so technical teams can <br className="hidden md:block" /> <span className="pl-1">focus on what they do best — building great products.”</span>
              </div>
              <div className="text-center pb-16 text-xl leading-md"> <span className="font-bold">Asim M., </span> <span className="font-normal">Engineering Leader</span></div>
            </div>
          </SdfBox>
          <img src={img} className="absolute bottom-0 image-position" alt="Message" />
        </div>
      </div>
    </div>
    <div className="">
      <div className="flex flex-col xl:flex-row lg:justify-center lg:items-center gap-8 lg:h-full xl:gap-24 lg:gap-10 lg:py-20 p-10">
        <div className="pt-2 lg:pt-0">
          <div className="font-medium leading-md tracking-lg" style={{ color: "#D0271D" }}>END-TO-END SOLUTION</div>
          <div className="pt-2">
            <div className="font-medium font-black text-3xl leading-sm pb-3">APIs for flexibility, UIs for speed</div>
            <div className="py-2 leading-md">
              ADP provides a complete, flexible payroll solution, whether you need <br className="hidden md:block" /> embedded payroll features or API integration:
            </div>

            <FeatureItem
              boldText="Intuitive, prebuilt components"
              description=" let you integrate ADP payroll directly"
              subText="into your platform"
            />
            <FeatureItem
              boldText="API-driven backend"
              description=" helps you tailor your payroll offering to your"
              subText="customers"
            />
            <FeatureItem
              boldText="Sandbox environment"
              description="lets you simulate real-world payroll in a risk-free"
              subText="environment"
            />
            <FeatureItem
              boldText="Robust infrastructure"
              description="minimizes disruptions to your workflow for a fast"
              subText="launch"
            />

          </div>
        </div>
        <div>
          <video controls autoPlay loop muted className="cursor-pointer w-full">
            <source src={EmbeddedDev_Flexibility} />
          </video>
        </div>
      </div>

    </div>

    <div className="xl:h-xs bg-action-primary-900">
      <div className="text-center text-inverse-default flex flex-col justify-center items-center h-full p-4">
        <div className="text-3xl leading-md font-medium">Everything to integrate payroll, from start to launch</div>
        <div className="leading-md pt-2 lg:pt-6">Ready to build? Dive into the technical details with our comprehensive API documentation, code samples, and integration guides.</div>
        <SdfLink
          target='_blank'
          className="pb-2 pt-8 font-medium lg:font-bold leading-md  text-center"
          emphasis="primary"
          href='https://adpembeddedpayroll.readme.io/docs/overview-1'
        >
          View Developer Documentation
        </SdfLink>
      </div>


    </div>

    <div className=" bg-action-primary-50">
      <div className="flex flex-col xl:flex-row lg:justify-center lg:items-center p-6 md:p-10 gap-12 lg:h-full xl:gap-32 lg:py-24">
        <img src={embeddedDev_Compliance} className="lg:h-sm lg:w-auto md:w-4/6 order-2 md:order-1" alt="Compliance" />
        <div className="pt-4  lg:pt-0 order-1 md:order-2">
          <div className="font-medium leading-md tracking-lg" style={{ color: "#D0271D" }}>COMPLIANCE CONFIDENCE</div>
          <div className="pt-2">
            <div className="font-black text-3xl leading-sm">
              Nationwide compliance expertise
            </div>
            <div className="py-2 leading-md">
              ADP’s platform comes with built-in tools, backed by nationwide <br className="hidden md:block"/> monitoring, to help you stay compliant:
            </div>
            <FeatureItem
              boldText="Automated tax filings and calculations"
              description="across all 50 states"
            />
            <FeatureItem
              boldText="Real-time updates"
              description="for changes in payroll regulations and tax laws"
            />
            <FeatureItem
              boldText="A team of compliance experts"
              description="monitoring state and federal"
              subText="requirements to help ensure accuracy"
            />
            <FeatureItem
              boldText="Automatic adjustments"
              description="for complex multi-state payroll regulations"
            />

          </div>
        </div>
      </div>
    </div>
    <div>

      <div className="">
        <div className="flex flex-col xl:flex-row lg:justify-center lg:items-center gap-8 lg:h-full xl:gap-20 lg:gap-10 lg:py-12 p-10">
          <div className="pt-2 lg:pt-0">
            <div className="font-medium leading-md tracking-lg" style={{ color: "#D0271D" }}>EXPERT SERVICE & SUPPORT</div>
            <div className="pt-2">
              <div className="font-medium font-black text-3xl leading-sm pb-3">
                Support your devs, delight your <br className="hidden md:block"/>customers
              </div>
              <div className="py-2 leading-md">
                ADP offers comprehensive support to help you integrate payroll quickly <br className="hidden md:block"/> and efficiently:
              </div>
              <FeatureItem
                boldText="Hands-on support"
                description=" during the integration process, with post-launch"
                subText="support via developer-focused channels"
              />
              <FeatureItem
                boldText="Access to live documentation,"
                description="API guides and other technical"
                subText="resources"
              />
              <FeatureItem
                boldText="Dedicated account representatives"
                description="to assist with onboarding and"
                subText="setup"
              />
              <FeatureItem
                boldText="Access to ADP's payroll support team"
                description="to assist your end customers"
              />
            </div>
          </div>
          <video controls autoPlay loop muted className="cursor-pointer">
            <source src={EmbeddedDev_ExpertSupport} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>

    <div className="bg-action-default-50">
      <div className="flex flex-col xl:flex-row lg:justify-center lg:items-center lg:h-full gap-8 xl:gap-32 lg:gap-10 p-6 lg:py-24 p-10">
        <img src={embeddedDev_Security} className="lg:h-sm md:w-3/6 lg:w-auto order-2 md:order-1" alt="Security" />
        <div className="pt-2  lg:pt-0 order-1 md:order-2">
          <div className="font-medium leading-md tracking-lg" style={{ color: "#D0271D" }}>DATA SECURITY & PRIVACY</div>
          <div className="pt-2">
            <div className="font-black text-3xl leading-sm pb-3">
              Engineered for trust at every level
            </div>
            <div className="py-2 leading-md">
              Count on ADP's best-in-class data protection with robust security <br className="hidden md:block"/> features:
            </div>
            <FeatureItem
              boldText="End-to-end encryption"
              description="to secure payroll and personal data"
            />
            <FeatureItem
              boldText="Regular audits"
              description="to maintain compliance with global privacy regulations"
            />
            <FeatureItem
              boldText="Advanced fraud detection and risk monitoring tools"
              description="to safeguard"
              subText="against threats"
            />
            <FeatureItem
              boldText="Secure data handling protocols"
              description="to protect sensitive information at all"
              subText="times"
            />
            <FeatureItem
              boldText="Enterprise-grade security measures,"
              lastText="including"
              description="ISO, SOC 1 and 2 and"
              subText="more"
              styles={{ color: "#2F6CFE", lineHeight: "24px", fontWeight: 'bold' }}
            />
          </div>
        </div>
      </div>
    </div>

    <div className="xl:h-sm bg-action-primary-900 p-4">
      <div className="text-center text-inverse-default flex flex-col justify-center items-center h-full">
        <div className="text-sm font-bold leading-none pb-4 md:pb-1 pl-1" style={{ color: "#F2635D" }}>DOCUMENTATION</div>
        <div className="text-3xl leading-md font-medium">Ready to build?</div>
        <div className="leading-md pt-4 md:pt-2 lg:pt-6">Access comprehensive API documentation, guides and resources to help you every step of the way.</div>
        <div className="flex flex-col lg:flex-row gap-4 md:gap-2 pt-4 md:pt-2 lg:pt-8">
          <SdfLink
            target='_blank'
            className="lg:w-44 lg:h-auto"
            emphasis="primary"
            href='https://www.adp.com/what-we-offer/products/adp-embedded-payroll.aspx#bop'
          >
            Start Building
          </SdfLink>
          <SdfLink
            target='_blank'
            className="font-bold leading-md text-center lg:w-72 lg:h-auto"
            emphasis="secondary"
            href='https://adpembeddedpayroll.readme.io/docs/overview-1'
          >
            View Developer Documentation
          </SdfLink>
        </div>
      </div>
    </div>

    <div style={{ backgroundColor: "#FFFFFF" }} className="lg:h-md">
      <div className="flex justify-center items-center h-full p-8">
        <div className="flex flex-col md:flex-row gap-4 xl:gap-10">
          <div>
            <img src={ADPLogo} alt="ADP Logo" />
          </div>
          <div className="text-sm leading-lg">
            <span className="pb-4 block">* Business.com Article “Best Business Employee Retirement Plans of 2022” published on August 24, 2022. </span>

            Unless otherwise disclosed or agreed to In writing with a client ADP, Inc. and Its affiliates (ADP) do not endorse or recommend specific Investment companies or products, financial advisors<br className="hidden xl:block element-visibility" />
            or service providers; engage or compensate any financial advisors to provide advice to plans or participants; offer financial. Investment, tax or legal advice or management services; or serve<br className="hidden xl:block element-visibility" />
            In a fiduciary capacity with respect to retirement plans. Only registered representatives of ADP Broker Dealer, Inc. (ADP BD). Member FINRA, or. In the case of certain products, a broker- <br className="hidden xl:block element-visibility" />
            dealer firm that has executed a marketing agreement with ADP. Inc., may offer and sell ADP retirement products or speak to retirement plan features and/or Investment options available In<br className="hidden xl:block element-visibility" />
            such ADP retirement products, and only associated persons of ADP Strategic Plan Services, LLC (SPS) may speak to any Investment management or advisory services provided by SPS or<br className="hidden xl:block element-visibility" />
            any third party In connection with such ADP retirement products. SPS Is an SEC Registered Investment Adviser. Registration does not Imply a certain level of skill or services. Plan sponsors<br className="hidden xl:block element-visibility" />
            and plan administrators may wish to seek the advice of legal counsel or a tax professional to address their specific situations. ADP, the ADP logo, SMARTSync and Always Designing for<br className="hidden xl:block element-visibility" />
            People are trademarks of ADP, Inc. All other trademarks and service marks are the property of their respective owners. Copyright © 2022 ADP, Inc. All Rights Reserved.<br className="hidden xl:block element-visibility" />
            ADPRS-20230518-4521
          </div>
        </div>
      </div>
    </div>
  </div>)

}

export default EmbeddedPayroll;